import type { StepConfig } from '~/ui-rocco/multi-step-form';
import { HDEIntroStep } from './HDEIntroStep';
import { HDEApplicationTypeStep } from './HDEApplicationTypeStep';

/** Homeowner indicator step count: 1 (application-type) + 6 form steps (guest-invitation through project-location) */
export const HOMEOWNER_INDICATOR_STEP_COUNT = 7;

export const INITIAL_FLOW_STEP_CONFIGS: StepConfig[] = [
    {
        id: 'intro',
        title: 'Register for Home Design Evening',
        component: HDEIntroStep,
        skippable: false,
    },
    {
        id: 'application-type',
        title: 'Who are you?',
        component: HDEApplicationTypeStep,
        skippable: false,
        hideNextButton: true,
        showBackInsteadOfCancel: true,
    },
];
